import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonRow = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 1fr 220px 150px 20px;
  gap: 8px;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #e5e7eb;
  min-height: 60px;

  @media (max-width: 768px) {
    min-width: 490px;
  }
`;

const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "20px"};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

const SkeletonCheckbox = styled(SkeletonBox)`
  width: 20px;
  height: 20px;
  margin: 0 auto;
`;

const SkeletonToggle = styled(SkeletonBox)`
  width: 44px;
  height: 24px;
  border-radius: 12px;
`;

interface FeeRowSkeletonProps {
  count?: number;
}

export const FeeRowSkeleton = ({ count = 5 }: FeeRowSkeletonProps) => {
  // Generate stable keys for skeleton rows
  const skeletonKeys = Array.from(
    { length: count },
    (_, i) => `skeleton-${i}-${Math.random().toString(36).substr(2, 9)}`
  );

  return (
    <>
      {skeletonKeys.map(key => (
        <SkeletonRow key={key}>
          {/* Selected checkbox */}
          <SkeletonCheckbox />

          {/* Name */}
          <SkeletonBox height="16px" width="60%" />

          {/* Empty cell for new column */}
          <div />

          {/* Include toggle */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginLeft: "-10px"
            }}
          >
            <SkeletonToggle />
          </div>

          {/* Amount */}
          <div style={{ display: "flex", marginLeft: "-10px" }}>
            <SkeletonBox height="16px" width="80px" />
          </div>

          {/* Right spacing */}
          <div />
        </SkeletonRow>
      ))}
    </>
  );
};
